import * as yup from 'yup';

export const SellersValidationSchema = yup.object().shape({
  name: yup.string().required( 'El nombre es requerido' ),
  lastname: yup.string().required( 'El apellido es requerido' ),
  email: yup.string().required( 'El correo es requerido' ),
  identification: yup.number().required( 'El número de dédula es requerido' ),
  phone: yup.mixed().required( 'El número de teléfono es requerido' ),
});
